export class ChargeIndicator {
  constructor(chargeIndicatorName?: string, confidence?: number) {
    this.chargeIndicatorName = chargeIndicatorName;
    this.confidence = confidence;
  }
  chargeIndicatorName: string;
  confidence: number;
}
